export const enum Gender {
	MALE,
	FEMALE,
}

export const GenderOptions = [
	{ label: 'Masculino', value: Gender.MALE },
	{ label: 'Feminino', value: Gender.FEMALE },
];
